import { makeStyles } from "@material-ui/core";
import { color } from "../../../../app/theme";

export const useSelectAddOnsExtraServicesStyles = makeStyles((theme) => ({
  title: {
    marginBottom: 10,
    fontFamily: "Axiforma, serif, sans-serf !important",
    fontWeight: 500,
    fontSize: "18px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "15px"
    }
  },
  content: {
    "fontSize": "14px",
    "alignItems": "center",
    "& .description": {
      marginRight: "12px",
      color: "#929292"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  moreDetails: {
    color: "#f7815c",
    marginLeft: 13,
    fontFamily: "Axiforma, serif, sans-serf !important"
  },
  price: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    marginTop: 15,
    marginBottom: 15,
    fontSize: "18px",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px"
    }
  },
  showQuantity: {
    backgroundColor: "#f3f3f3",
    borderRadius: 20,
    width: 130,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: 128
    }
  },
  button: {
    "color": "#f7815c",
    "borderRadius": 20,
    "width": 40,
    "height": 31,
    "border": 0,
    "cursor": "pointer",
    "&:disabled": {
      color: "#d0d0d0"
    }
  },
  add: {
    "color": "#f7815c",
    "width": 102,
    "height": 38,
    "marginLeft": 20,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0
    },
    "borderRadius": 20,
    "fontSize": "14px",
    "backgroundColor": "white",
    "border": "1px solid #f7815c",
    "&.add": {
      [theme.breakpoints.down("sm")]: {
        marginLeft: "0 !important"
      }
    },
    "&:disabled": {
      color: "#f7815c"
    }
  },
  buttonAdd: {
    color: "#f7815c"
  },
  next: {
    "width": "204px",
    "height": "53px",
    "borderRadius": "27px",
    "fontSize": "20px",
    "fontWeight": 500,
    "background": color.orange,
    "color": "#fff",
    "marginTop": "50px",
    "marginBottom": "30px",
    "&:hover": { background: color.orange, color: "#fff" },
    "&:disabled": {
      background: color.orange,
      color: "#fff",
      opacity: "0.5"
    },
    [theme.breakpoints.down("sm")]: {
      width: 150,
      height: 40,
      fontSize: 14,
      marginBottom: "20px"
    }
  },
  moreDetailsBtn: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    color: "#f7815c",
    marginLeft: 13,
    fontSize: "12px",
    fontWeight: 600,
    display: "inline-block",
    padding: 0,
    textDecoration: "underline",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  priceSubscription: {
    "fontSize": "14px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px"
    },
    "& .price": {
      "fontFamily": "Axiforma, serif, sans-serf !important",
      "& span": {
        fontSize: "30px",
        fontWeight: 600,
        [theme.breakpoints.down("xs")]: {
          fontSize: "23px"
        }
      },
      "fontSize": "14px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px"
      }
    },
    [theme.breakpoints.down("xs")]: {
      width: "50%"
    }
  },
  benefits: {
    "fontFamily": "Axiforma, serif, sans-serf !important",
    "fontSize": "12px",
    "color": "#4b5462",
    "& li": {
      "marginBottom": "10px",
      "& a": {
        color: color.orange,
        marginLeft: 4
      }
    }
  },
  benefitsStr: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    fontSize: "14px",
    color: "#4b5462",
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px"
    }
  }
}));
